import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from './ApiService';
import toast from 'react-hot-toast';

interface CartItem {
  type: string;
  refId: number;
  amount: number;
}

interface PayPalCheckoutProps {
  cart: CartItem;
  onSuccess?: (transaction: any) => void;
  onError?: (error: any) => void;
  onCancel?: () => void;
}

const PayPalButton: React.FC<PayPalCheckoutProps> = ({
  cart,
  onSuccess,
  onError,
  onCancel,
}) => {
  const [message, setMessage] = useState<string>("");

  // Constants for your entire app
  //const CLIENT_ID = "AdgNBvGZszA5OggLqdnL2rbvJ4N-dVANSjE7hWGLnD0n_ORInlyTJI_ucjhoqdFNZiaVAQTsKwC16M3e" //Sandbox
  const CLIENT_ID = "AbTrICIbqmkf3j12Ug7IK5Y-3ssGQcJyBwZS0UPAwyyPmDMyFvzZjJRaI6YljtpWSlRIWtYLYeqsfGhy"
  const CURRENCY = "AUD";
  const COUNTRY = "AU";

  const initialOptions = {
    clientId: CLIENT_ID,
    currency: CURRENCY,
    components: "buttons"
    //"enable-funding": "venmo",
    //"buyer-country": COUNTRY
  };

  return (
    <div className="paypal-button-container">
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{
            shape: "rect",
            layout: "vertical",
            color: "gold",
            label: "paypal",
          }}
          createOrder={async () => {
            try {
              const response = await axios.post("/createPaypalOrder", cart);
              const orderData = await response.data;

              if (orderData.id) {
                return orderData.id;
              } else {
                const errorDetail = orderData?.details?.[0];
                const errorMessage = errorDetail
                  ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                  : JSON.stringify(orderData);

                throw new Error(errorMessage);
              }
            } catch (error) {
              console.error(error);
              toast.error(`Could not initiate PayPal Checkout`);
            }
          }}
          onApprove={async (data, actions) => {
            try {
              const response = await axios.post("/capturePaypalOrder", { orderID: data.orderID });
              const orderData = await response.data;
              const errorDetail = orderData?.details?.[0];

              if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                return actions.restart();
              } else if (errorDetail) {
                throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
              } else {
                const transaction = orderData.purchase_units[0].payments.captures[0];
                const msg = `Transaction ${transaction.status}: ${transaction.id}`;
                setMessage(msg);
                console.log("Capture result", orderData, JSON.stringify(orderData, null, 2));
                onSuccess?.(transaction);
              }
            } catch (error) {
              // console.error(error);
              // const errMsg = `Sorry, your transaction could not be processed...${error}`;
              // setMessage(errMsg);
              // onError?.(error);
              toast.error(`Sorry, your transaction could not be processed. Please wait for an hour before trying again.`);
            }
          }}
          onCancel={() => {
            setMessage("Payment cancelled.");
            onCancel?.();
          }}
        />
      </PayPalScriptProvider>
      {message && <p>{message}</p>}
    </div>
  );
};

export default PayPalButton; 